<template>
    <div id="upload_picture">
      <v-row>
        <v-col>
            <p>{{ $tc("memberRegistration.step_upload_picture.content.line_1") }}</p>
            <p>{{ $tc("memberRegistration.step_upload_picture.content.line_2") }}</p>
        </v-col>
      </v-row>
      <v-col>
        <v-row>
            <v-col>
              <div v-for="(participant, index) in selectedParticipants" :key="participant.id">
                <div class="profile-container mb-4">
                    <div class="profile-info">
                        <img :src="participant.image" class="profile-image" alt="Profile" />
                        <div class="user-details">
                            <h3>{{ participant.lName }} {{ participant.fName }}</h3>
                            <p>{{ $tc("memberRegistration.step_upload_picture.content.livelaps_id") }}: {{ participant.userId }}</p>
                        </div>
                    </div>
                    
                    <div class="buttons">                        
                        <button @click="openAvatarCopper(index)">
                            {{ $tc("memberRegistration.step_upload_picture.content.upload_picture") }}
                        </button>
                        <button @click="takeSelfie(index)">
                            {{ $tc("memberRegistration.step_upload_picture.content.take_photo") }}
                        </button>
                        <Cropper 
                            :ref="`selfieCropperRef`" 
                            :buttonColor="buttonColor" 
                            :participantId="participant.userId"
                            type="selfie"
                            @uploadCropperImage="uploadCropperImage" 
                            style="float: right;" 
                        />
                        <Cropper 
                            :ref="`avatarCropperRef`" 
                            :buttonColor="buttonColor"
                            :participantId="participant.userId"
                            @uploadCropperImage="uploadCropperImage" 
                            style="float: right;" />
                    </div>
                </div>
              </div>
            </v-col>
        </v-row>
      </v-col>
  
      <v-row>
        <v-col md="6" sm="6" cols="6" class="text-left">
          <v-btn :color="`${buttonColor}`" class="btn_next" @click="setStep(prevStep)">{{
            $tc("registerEvent.prev")
          }}</v-btn>
        </v-col>
        <v-col md="6" sm="6" cols="6" class="text-right">
          <v-btn :color="`${buttonColor}`" class="btn_next" :disabled="!allImageURLs" @click="setStep(nextStep)">{{
            $tc("registerEvent.next")
          }}</v-btn>
        </v-col>
      </v-row>
      <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
    </div>
  </template>
  
  <script>
  import Snack from "@/components/notifications/Snack";
  import { VRow, VCol, VBtn } from "vuetify/lib";
  import Cropper from "@/components/images/Cropper.vue"
  import axios from "axios";
  export default {
    components: {
      VRow,
      VCol,
      VBtn,
      Cropper,
      Snack
    },
    props: {
      step: Number,
      buttonColor: String,
      selectedParticipants: Array,
      previousStep: Number,
      nextStepValue: {
        type: Number,
        default: 4
      }
    },
    data() {
      return {
        imagePreview: null,
        defaultImage: require("@/assets/images/partPlaceholder.jpg"),
        msg_snackbar: '',
        color_snackbar: '',
        snackbar: false,
      };
    },
    computed: 
    {
      allImageURLs()
      {
        return this.selectedParticipants && this.selectedParticipants.every(participant => participant.imagenUrl);
      },
      prevStep()
      {
        return this.previousStep;
      },
      nextStep()
      {
        return this.nextStepValue;
      }
    },
    watch: {
      feedback(val) {
        this.$emit("updateFeedback", val);
      },
    },
    methods: {
      showSnackBar(msg, color){
        this.snackbar = true;
        this.msg_snackbar = msg;
        this.color_snackbar = color;
        setTimeout(() => this.snackbar = false, 3000);
      },
      setStep(step) {
        this.$emit("nextStep", step);
      },
      takeSelfie(index) {
        let selfieComponent = this.$refs.selfieCropperRef[index];
        if(selfieComponent) {
            selfieComponent.openSelfie();
        }
      },
      openAvatarCopper(index){
        let avatarCopperComponent = this.$refs.avatarCropperRef[index];
        if(avatarCopperComponent) {
            avatarCopperComponent.open();
        }
      },
      uploadCropperImage(data) {
        const { base64Image } = data;
        const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, "");
        var byteCharacters = atob(base64Data);

        var byteArray = new Uint8Array(byteCharacters.length);

        for (var i = 0; i < byteCharacters.length; i++)
        {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        
        let _participant = this.selectedParticipants.find(participant => participant.userId === data.userId);

        var blob = new Blob([byteArray], { type: 'image/png' });

        var file = new File([blob], `${data.userId}_${_participant.fName}_${_participant.lName}.png`, { type: 'image/png' });

        this.uploadImage_ = file;
        this.fileName = `${data.userId}_${_participant.fName}_${_participant.lName}.png`;
        let index = this.selectedParticipants.findIndex(participant => participant.userId === data.userId);
        if (index !== -1) {
          this.selectedParticipants[index].imagenUrl = base64Image;
          this.selectedParticipants[index].image = base64Image;
        }
        //this.uploadImage(userId, base64Image);
      },
      async uploadImage(userId, base64Image){
        const data = new FormData();
        data.append("image", this.uploadImage_);
        data.append("fileName", this.fileName);
        data.append("userId", userId);
        let axiosConfig = {
          headers: { "content-type": "multipart/form-data", "files": true },
        };
        const response = await axios
          .put(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/register/organization/updateHeadShot/`, data, axiosConfig)
          .catch( function (error) {
            if(!error.response)
            {
                this.showSnackBar('unexpextedError', 'error');
                return false;
            }
          }.bind(this));
              
          if (response && response.data && response.data.success == 1)
          {
            let index = this.selectedParticipants.findIndex(participant => participant.userId === userId);
            if (index !== -1) {
              this.selectedParticipants[index].imagenUrl = response.data.message;
              this.selectedParticipants[index].image = base64Image;
            }
          }else{
            this.showSnackBar(this.$t(`memberRegistration.step_upload_picture.error.${response.data.message}`), 'error');
          }
      },
    },
  };
  </script>
  
<style>
.profile-container {
    display: flex;
    background: #e6f2ec;
    padding: 10px;
    border-radius: 8px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}
.profile-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}
.user-details h3 {
  margin: 0;
}
#upload_picture .buttons {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}
#upload_picture button {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  text-transform: uppercase;
}
.hidden {
  display: none;
}
</style>
  